export default __webpack_public_path__ + "static/media/Leggings of the Death God.d69d73c9.jpg";